/**
 * Returns a deeply cloned object without reference.
 * Copied from Vuex.
 * @type {Object}
 */
export default function deepClone (obj) {
  if (Array.isArray(obj)) {
    return obj.map(deepClone)
  } else if (obj && typeof obj === 'object') {
    var cloned = {}
    var keys = Object.keys(obj)
    for (var i = 0, l = keys.length; i < l; i++) {
      var key = keys[i]
      cloned[key] = deepClone(obj[key])
    }
    return cloned
  } else {
    return obj
  }
}



// WEBPACK FOOTER //
// ./src/core/components/edSelect/utils.js